import React from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterComponent from "../../components/Auth/RegisterComponent";

const RegisterPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/dang-nhap.html');
    }

    return <RegisterComponent redirect={ () => redirect() } />

}

export default RegisterPage;